<template>
  <div v-if="internalUser">
    <PageHeader link-name="Назад" link-path="InternalUsers" :page-name="internalUserName">
      <template>
        <el-avatar
          v-if="internalUser.avatar"
          shape="square"
          :size="50"
          :src="internalUser.avatar.path"
        />
      </template>
    </PageHeader>
    <el-card class="box-card">
      <el-descriptions border :column="1">
        <el-descriptions-item label="Пользователь">{{ internalUser.username }}</el-descriptions-item>
        <el-descriptions-item label="Имя">{{ internalUser.first_name }}</el-descriptions-item>
        <el-descriptions-item label="Фамилия">{{ internalUser.last_name }}</el-descriptions-item>
        <el-descriptions-item label="Тип акаунта">{{ internalUser.account_type }}</el-descriptions-item>
        <el-descriptions-item label="Тип пакета">{{ internalUser.package_type }}</el-descriptions-item>
        <el-descriptions-item label="Рейтинг">
          {{ internalUser.rating }}
        </el-descriptions-item>
        <el-descriptions-item label="Дата регистрации">{{ internalUser.registration_date }}</el-descriptions-item>
        <el-descriptions-item v-if="internalUser.achievements.length > 0" label="Активные ачивки">
          <el-tag v-for="achievement in internalUser.achievements" :key="achievement.title" type="success">{{ achievement.title }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="Удаление пользователя">
          <el-button type="danger" @click="deleteInternalUser">
            <i class="fas fa-remove" /> Удалить внутреннего пользователя
          </el-button>
        </el-descriptions-item>
        <el-descriptions-item label="Зробити виконавцем і оживити">
          <el-button type="success" @click="makeInternalUserContractor">
            <i class="fas fa-floppy-disk" /> Зробити цього міньйона виконавцем і оживити
          </el-button>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card v-if="showCreateContractorForm" class="box-card mt-20">
      <el-form
        ref="form"
        label-position="top"
        :model="form"
        :rules="rules"
        @submit.native.prevent="onSubmit"
      >
        <div class="row">
          <div class="col-md-4">
            <el-form-item label="Назва профілю" prop="username">
              <el-input v-model="form.username" />
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <el-form-item label="Опис" prop="description">
              <EditableWysiwygText ref="editableText" v-model="form.description" is-opened />
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 editable-text-container">
            <el-form-item label="Місцезнаходження" prop="city_id">
              <el-select
                v-if="cityOptions"
                v-model="form.city_id"
                filterable
                placeholder="Введите город"
                remote
                :remote-method="getCity"
                reserve-keyword
              >
                <el-option
                  v-for="item in cityOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <el-form-item label="Номер телефону" prop="phone">
              <el-input v-model="form.phone" />
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <el-form-item label="Електронна пошта" prop="email">
              <el-input v-model="form.email" />
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <el-form-item label="Категорія" prop="category_id">
              <td>
                <el-select
                  ref="categorySelect"
                  v-model="form.category_id"
                  class="category-select"
                  :filter-method="filterMethod"
                  filterable
                  no-data-text="Ничего не найдено"
                  placeholder="Виберите категорию"
                >
                  <el-option-group
                    v-for="group in filteredCategories"
                    :key="group.id"
                    :label="group.name"
                  >
                    <el-option
                      v-for="category in group.children"
                      :key="category.id"
                      :label="category.name"
                      :value="category.id"
                    />
                  </el-option-group>
                </el-select>
              </td>
            </el-form-item>
          </div>
        </div>

        <div class="text-right">
          <el-button
            type="primary"
            @click="onSubmit"
          >
            Сохранить
          </el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import {mapActions} from 'vuex';
import PageHeader from '@/components/common/PageHeader';
import EditableWysiwygText from '@/components/common/EditableWysiwygText.vue';

export default {
  name: 'ViewPage',
   components:{EditableWysiwygText, PageHeader},
  data(){
    return {
      internalUser: null,
      showCreateContractorForm: false,
      form: {
        username: '',
        description: '',
        city_id: null,
        phone: '',
        email: '',
        category_id: null,
      },
      cityOptions: [],
      categories: [],
      filteredCategories: [],
      selectedCityId: null,
      rules: {
        username: [
          { required: true, message: 'Введіть назву профілю', trigger: 'blur' },
          { min: 2, max: 50, message: 'Довжина має бути від 2 до 50 символів', trigger: 'blur' },
        ],
        description: [
          { required: true, message: 'Введіть опис', trigger: 'blur' },
        ],
        city_id: [
          { required: true, message: 'Виберіть місцезнаходження', trigger: 'change' },
        ],
        phone: [
          { required: true, message: 'Введіть номер телефону', trigger: 'blur' },
          {
            pattern: /^(?:\+38|38)?[- ]?(?:\([0-9]{3}\)|[0-9]{3})[- ]?[0-9]{3}[- ]?[0-9]{2}[- ]?[0-9]{2}$/,
            message: 'Введіть коректний номер телефону', trigger: 'blur' },
        ],
        email: [
          { type: 'email', message: 'Введіть коректну адресу електронної пошти', trigger: 'blur' },
        ],
        category_id: [
          { required: true, message: 'Виберіть категорію', trigger: 'change' },
        ],
      },
    }
  },

  computed:{
    internalUserName () {
      return `Внутренний пользователь: ${this.internalUser?.username}`
    },
  },

  async created() {
    this.internalUser = await this.fetchInternalUser(this.$route.params.id);
  },

  methods: {
    ...mapActions('internalUsers', [
      'fetchInternalUser',
      'createContractorFromInternalUser',
      'delete',
    ]),
    ...mapActions('cities', [
      'fetchCities','preloadCities',
    ]),
    ...mapActions('contractors', [
      'fetchContractorCategories',
    ]),

    async deleteInternalUser() {
      let confirmation = false
      try {
        confirmation = await this.$confirm('Ви впевнені, що хочете видалити внутрішнього користувача та усі його публікації?', {
          cancelButtonText: 'Ні',
          confirmButtonText: 'Так',
          type: 'warning',
          center: true,
        })
      } catch (e) {
      }
      if (!confirmation) {
        return
      }
      try {
        let result = await this.delete(this.internalUser.id)
        this.$message({
          showClose: true,
          message: result.message,
          type: 'success',
          duration: 0,
        });
      } catch (e) {
        console.log(e)
        this.$message.error('Не вдалося видалити внутрішнього користувача')
      }
      await this.$router.push({name: 'InternalUsers'});
    },

    async makeInternalUserContractor() {
      await this.getCities()
      await this.getCategories()
      this.showCreateContractorForm = !this.showCreateContractorForm;
    },

    async onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.$confirm(
            'Ви впевнені, що хочете створити виконавця з міньйона і оживити його? Це необоротно!',
            'Попередження',
            {
              confirmButtonText: 'Так',
              cancelButtonText: 'Ні',
              type: 'warning',
              center: true,
            },
          ).then(async () => {
            try {
              await this.createContractorFromInternalUser({id: this.internalUser.id, form: this.form});

              this.$message({
                message: 'Виконавець успішно створений',
                type: 'success',
                duration: 3000,
              });

              await this.$router.push({name: 'InternalUsers'});
            } catch (error) {
              this.$message({
                message: 'Помилка при створенні виконавця',
                type: 'error',
                duration: 3000,
              });
              console.error('Помилка при створенні виконавця:', error);
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: 'Створення скасовано',
            });
          });
        }
      });
    },

    async getCategories() {
      this.categories = await this.fetchContractorCategories()
      this.filteredCategories = this.categories
    },

    async getCities() {
      this.cityOptions = await this.preloadCities()
    },

    async getCity(query) {
      if (query !== '') {
        this.cityOptions = await this.fetchCities({ search: query });
      }
    },
    filterMethod(val) {
      if (!val) {
        this.filteredCategories = this.categories
      }
      const filteredGroups = this.categories.filter(group => group.name.toLowerCase().includes(val.toLowerCase()))
      const filteredChildren = this.categories.reduce((acc, group) => {
        const children = group.children?.filter(category => {
          return category.name.toLowerCase().includes(val.toLowerCase())
        })

        const isGroupAlreadyExist = filteredGroups.some(g => g.id === group.id)

        if (children.length > 0 && !isGroupAlreadyExist) {
          acc = [...acc, {
            id: group.id,
            name: group.name,
            children,
          }]
        }
        return acc
      }, [])

      this.filteredCategories = [...filteredGroups, ...filteredChildren]
    },
  },
}

</script>

<style lang="sass" scoped>
@import "@/assets/sass/_variables"

.mt-20
  margin-top: 20px

.editable-text-container
  display: flex
  align-items: center
  gap: 8px

  i
    font-size: 20px
    margin-right: 7px

</style>
